const KEY = 'ADDITIONAL';

export { KEY };
